module.exports = __webpack_public_path__ + "static/media/up-arrow.1f06a425.svg";